import React from 'react';
import { Store } from '@one-thd/sui-icons';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import {
  Link
} from '@one-thd/sui-atomic-components';
import { useStoreSearch } from './useStoreSearch';

export const MyStoreButton = ({
  storeId,
  onClick,
  showIcon = true,
  className = '',
  ...linkProps
}) => {
  const { storeName } = useStoreSearch({ storeId });
  if (!storeName) {
    return null;
  }

  return (
    <div className={`sui-flex sui-items-center sui-gap-2 ${className}`}>
      {showIcon && <Store />}
      <Link
        data-testid="store-name-text"
        component="button"
        onClick={onClick}
        underline="always"
        {...linkProps}
      >
        {storeName}
      </Link>
    </div>
  );
};

MyStoreButton.displayName = 'MyStoreButton';

MyStoreButton.propTypes = {
  storeId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  showIcon: PropTypes.bool,
  className: PropTypes.string
};

MyStoreButton.defaultProps = {
  storeId: '',
  showIcon: true,
  className: ''
};

MyStoreButton.dataModel = extend(
  useStoreSearch.dataModel
);
